import api from "./axios";

export const getCurrentLegalDocuments = () => api.get("/legal/documents/current");

export const getLegalConsentStatus = (workspaceId) =>
  api.get("/legal/status", {
    headers: { "X-Workspace-Id": workspaceId },
  });

export const acceptLegalDocuments = (workspaceId, payload) =>
  api.post("/legal/accept", payload, {
    headers: { "X-Workspace-Id": workspaceId },
  });
